"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOSTS_CONFIG = void 0;
exports.HOSTS_CONFIG = {
    dev: {
        browser: {
            kz: 'https://master-backend-metrics.dev.metrics.aservices.tech',
            ru: 'https://master-backend-metrics.dev.metrics.aservices.tech',
            ua: 'https://master-backend-metrics.dev.metrics.aservices.tech',
            uz: 'https://master-backend-metrics.dev.metrics.aservices.tech',
        },
        node: 'master-backend-metrics.dev.metrics.aservices.tech',
    },
    prod: {
        browser: {
            kz: 'https://capi.mcfr.kz/metrics/backend',
            ru: 'https://api.action-media.ru/metrics/backend',
            ua: 'https://capi.mcfr.ua/metrics/backend',
            uz: 'https://capi.mcfr.uz/metrics/backend',
        },
        node: 'backend-metrics.prod.metrics.aservices.tech',
    },
    rc: {
        browser: {
            kz: 'https://stable-backend-metrics.rc.metrics.aservices.tech',
            ru: 'https://stable-backend-metrics.rc.metrics.aservices.tech',
            ua: 'https://stable-backend-metrics.rc.metrics.aservices.tech',
            uz: 'https://stable-backend-metrics.rc.metrics.aservices.tech',
        },
        node: 'stable-backend-metrics.rc.metrics.aservices.tech',
    },
};
//# sourceMappingURL=hosts.js.map